var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "DemoStep",
    { attrs: { slug: "stepIntents" } },
    [
      _c("div", { staticClass: "question-item d-flex flex-column mt-3" }, [
        _c(
          "div",
          { staticClass: "header-container d-flex align-items-center" },
          [
            _c("v-icon", { attrs: { color: "primary lighten-3" } }, [
              _vm._v("mdi-check"),
            ]),
            _c(
              "div",
              {
                staticClass: "font-weight-bold text-body-1 primary--text ml-2",
              },
              [
                _vm._v(
                  " " + _vm._s(_vm.$t("demoStepIntents.aiAgent.title")) + " "
                ),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "text-body-2 grey--text text--darken-3 mt-2" },
          [
            _vm._v(
              " " + _vm._s(_vm.$t("demoStepIntents.aiAgent.description")) + " "
            ),
            _c("br"),
            _c("br"),
            _vm._v(
              " " + _vm._s(_vm.$t("demoStepIntents.aiAgent.contentLabel")) + " "
            ),
          ]
        ),
        _c(
          "ul",
          { staticClass: "product-advisors-list mt-2" },
          _vm._l(_vm.supportedActions, function (action, i) {
            return _c(
              "li",
              { key: i, staticClass: "d-flex gap-2 items-center" },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      width: "24px",
                      "max-height": "24px",
                      "flex-shrink": "0",
                    },
                  },
                  [
                    action.image
                      ? _c("img", {
                          staticClass: "full-width full-height",
                          attrs: { src: action.image, alt: "Service logo" },
                        })
                      : action.icon
                      ? _c("v-icon", [_vm._v(" " + _vm._s(action.icon) + " ")])
                      : _vm._e(),
                  ],
                  1
                ),
                _c("span", [_vm._v(_vm._s(action.label))]),
              ]
            )
          }),
          0
        ),
      ]),
      _c(
        "div",
        { staticClass: "question-item d-flex flex-column mt-3" },
        [
          _c(
            "div",
            { staticClass: "header-container d-flex align-items-center" },
            [
              _c("v-icon", { attrs: { color: "primary lighten-3" } }, [
                _vm._v("mdi-check"),
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "font-weight-bold text-body-1 primary--text ml-2",
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("demoStepIntents.knowledgeBase")) + " "
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "text-body-2 grey--text text--darken-3 mt-2" },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("demoStepIntents.knowledgeBaseDescription")) +
                  " "
              ),
              _c("br"),
              _c("br"),
              _vm._v(
                " " + _vm._s(_vm.$t("demoStepIntents.generatedAnswer")) + " "
              ),
            ]
          ),
          _c(
            "WidgetChatHistory",
            {
              staticStyle: { "background-color": "transparent" },
              attrs: { "min-height": "auto", "max-width": "100%" },
            },
            [
              _c("WidgetBotMessage", {
                attrs: {
                  avatar: _vm.$t(`demo.personas.${_vm.persona.id}.avatar`),
                  text: _vm.agentIntroduction,
                  "bg-color": "#eeeeee",
                },
              }),
              _c("WidgetUserMessage", {
                attrs: { text: _vm.features.answer.query, arrow: "" },
              }),
              _c("WidgetAIMessage", {
                attrs: {
                  avatar: _vm.$t(`demo.personas.${_vm.persona.id}.avatar`),
                  text: _vm.features.answer.answer,
                  arrow: "",
                  "force-rounded": "",
                  disclaimer: "",
                  "resources-used": [
                    {
                      type: "WEBPAGE",
                      source: _vm.companyUrl,
                    },
                  ],
                  "bg-color": "#eeeeef",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.features.product_advisor
        ? _c(
            "div",
            {
              staticClass:
                "question-item d-flex flex-column mt-3 highlight-item",
            },
            [
              _c(
                "div",
                { staticClass: "header-container d-flex align-items-center" },
                [
                  _c("v-icon", { attrs: { color: "#8046eb" } }, [
                    _vm._v("mdi-check"),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass:
                        "font-weight-bold text-body-1 primary--text ml-2",
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("demoStepIntents.productAdvisor")) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "text-body-2 grey--text text--darken-3 mt-2" },
                [
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("demoStepIntents.productAdvisorDescription")
                      ),
                    },
                  }),
                  _c("br"),
                  _c("br"),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("demoStepIntents.productAdvisorTopics")) +
                      " "
                  ),
                ]
              ),
              _c(
                "ul",
                { staticClass: "product-advisors-list mt-2" },
                _vm._l(_vm.features.product_advisors, function (advisors) {
                  return _c("li", { key: advisors }, [
                    _vm._v(" " + _vm._s(advisors) + " "),
                  ])
                }),
                0
              ),
            ]
          )
        : _vm._e(),
      _vm.features.livechat
        ? _c("div", { staticClass: "question-item d-flex flex-column mt-3" }, [
            _c(
              "div",
              { staticClass: "header-container d-flex align-items-center" },
              [
                _c("v-icon", { attrs: { color: "primary lighten-3" } }, [
                  _vm._v("mdi-check"),
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "font-weight-bold text-body-1 primary--text ml-2",
                  },
                  [_vm._v(" moinAI Livechat ")]
                ),
              ],
              1
            ),
            _c("div", {
              staticClass: "text-body-2 grey--text text--darken-3 mt-2",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("demoStepIntents.livechatDescription")
                ),
              },
            }),
          ])
        : _vm._e(),
      _c("DemoBtns", {
        on: {
          onBack: function ($event) {
            return _vm.back()
          },
          onNext: _vm.nextStep,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }